// src/apis/bookingpublicapis.js
import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/* ===========================================================
   1️⃣ Get Booking Page Full Details
   =========================================================== */
export async function getBookingPageDetails(booking_page_id) {
  try {
    const fd = new FormData();
    fd.append("booking_page_id", booking_page_id);

    const res = await axios.post(
      `${apiBaseUrl}bookingpagepublic/get_booking_page_details`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    console.error("getBookingPageDetails error:", err);
    return {
      status: false,
      success: "Failed to load booking page details"
    };
  }
}

/* ===========================================================
   2️⃣ Get Available Slots for Date
   =========================================================== */
export async function getAvailableSlots(booking_page_id, date) {
  try {
    
    const fd = new FormData();
    fd.append("booking_page_id", booking_page_id);
    fd.append("date", date);

    const res = await axios.post(
      `${apiBaseUrl}bookingpagepublic/get_available_slots`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    console.error("getAvailableSlots error:", err);
    return {
      status: false,
      success: "Failed to get available slots"
    };
  }
}

/* ===========================================================
   3️⃣ Create Appointment
   (Full Flow: Customer → Form → Package → Payment)
   =========================================================== */
export async function createAppointment(appointmentData) {
  try {
    // Convert to Base64 JSON
    const encoded = btoa(JSON.stringify(appointmentData));

    const fd = new FormData();
    fd.append("appointment_data", encoded);

    const res = await axios.post(
      `${apiBaseUrl}bookingpagepublic/create_appointment`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    console.error("createAppointment error:", err);
    return {
      status: false,
      success: "Failed to book appointment"
    };
  }
}
